<div class="pick" *ngIf="state as s">
  <header class="pick__hdr">
    <h2 class="ss-page-title">BatchPick — {{ s.batchId }}</h2>
    <div class="pick__hdr-meta">
      <span>{{ remainingCount }} meds remaining</span>
      <span>{{ completeBaskets }} / {{ totalBaskets }} boxes</span>
    </div>
    <div class="pick__layout-toggle" role="group" aria-label="Layout">
      <button type="button"
              [class.active]="layout === 'tiles'"
              (click)="setLayout('tiles')">Tiles</button>
      <button type="button"
              [class.active]="layout === 'grid'"
              (click)="setLayout('grid')">Box Grid</button>
    </div>
    <button type="button" class="btn btn-outline-secondary" (click)="printPickList()">Print Pick List</button>
  </header>

  <div class="pick__scan" *ngIf="s.status === 'Pending'">
    <button class="btn btn-primary" (click)="openStartDialog()">Start Picking</button>
  </div>

  <div class="pick__scan" *ngIf="s.status === 'Picking'">
    <input #scanInput class="form-control" placeholder="Scan barcode..."
           [(ngModel)]="barcode" (keyup.enter)="scan()" autofocus>
    <button class="btn btn-outline-primary" (click)="openPrintPanel()">Print basket labels</button>
    <button class="btn btn-primary" (click)="finish()" [disabled]="finishing">Finish Picking</button>
  </div>

  <div class="pick__banner" *ngIf="banner" [ngClass]="'pick__banner--' + banner.type">{{ banner.text }}</div>

  <ng-container *ngIf="layout === 'tiles'; else gridShell">
    <div class="pick__grid">
      <div *ngFor="let b of s.baskets; trackBy: trackByBasket"
           class="basket"
           (click)="openBatchDetail(b)"
           [class.basket--current]="b.basketNumber === currentBasket && !basketComplete(b)"
           [class.basket--complete]="basketComplete(b)"
           [class.basket--pulse]="b.basketNumber === pulseBasket">
        <div class="basket__head">
          <span class="basket__num">#{{ b.basketNumber }}</span>
          <span class="basket__name">{{ b.patientName }}</span>
        </div>
        <ul class="basket__meds">
          <li *ngFor="let m of b.medications; trackBy: trackByMed"
              class="med"
              [class.med--picked]="medPicked(m)"
              [class.med--missing]="m.pickScanStatus === 'Missing'">
            <span class="med__mark"
                  [class.med__mark--ok]="medPicked(m)"
                  [class.med__mark--missing]="m.pickScanStatus === 'Missing'">
              <ng-container *ngIf="medPicked(m)">✓</ng-container>
              <ng-container *ngIf="m.pickScanStatus === 'Missing'">✕</ng-container>
              <ng-container *ngIf="m.pickScanStatus === 'NotPicked'">○</ng-container>
            </span>
            <span class="med__name">{{ m.medicationName }}</span>
            <span class="med__alt" *ngIf="m.pickScanStatus === 'PickedAsSubstitute'">ALT</span>
          </li>
        </ul>
      </div>
    </div>
  </ng-container>

  <ng-template #gridShell>
    <div class="pick__box-grid-shell">
      <aside class="pick__box-grid-left">
        <app-current-scan-panel
          [lastScan]="lastScan"
          (reset)="clearLastScan()">
        </app-current-scan-panel>
      </aside>
      <section class="pick__box-grid-center">
        <app-box-grid
          [baskets]="s.baskets"
          [currentBasket]="currentBasket"
          [pulseBasket]="pulseBasket"
          (basketClick)="openBatchDetail($event)">
        </app-box-grid>
      </section>
      <button type="button" class="pick__feed-toggle"
              (click)="toggleFeedDrawer()"
              [class.active]="feedDrawerOpen"
              [attr.aria-expanded]="feedDrawerOpen"
              aria-controls="pick-activity-drawer">
        Activity
      </button>
      <aside id="pick-activity-drawer"
             class="pick__box-grid-right"
             role="complementary"
             aria-label="Activity feed"
             [class.is-open]="feedDrawerOpen"
             [attr.aria-hidden]="!feedDrawerOpen">
        <app-activity-feed [baskets]="s.baskets"></app-activity-feed>
      </aside>
    </div>
  </ng-template>

  <div class="pick__readonly" *ngIf="s.status !== 'Pending' && s.status !== 'Picking'">
    This batch has been finished. Picking is closed.
  </div>

  <div class="pick__dialog-backdrop" *ngIf="showStartDialog">
    <div class="pick__dialog" role="dialog" aria-modal="true" aria-label="Start basket number">
      <h3>Start basket number</h3>
      <p>Baskets are numbered from here. Use the first free basket on your bench.</p>
      <input type="number" min="1" class="form-control"
             [(ngModel)]="startNumber" (keyup.enter)="confirmStart()" autofocus>
      <div class="pick__dialog-actions">
        <button class="btn btn-secondary" (click)="cancelStart()">Cancel</button>
        <button class="btn btn-primary" (click)="confirmStart()">Start picking</button>
      </div>
    </div>
  </div>

  <div class="pick__dialog-backdrop" *ngIf="showPrintPanel">
    <div class="pick__dialog pick__dialog--wide" role="dialog" aria-modal="true" aria-label="Print basket labels">
      <h3>Print basket labels</h3>

      <label class="pick__printer-row" *ngIf="nsPrinters.length">
        Printer
        <select class="form-control" [ngModel]="nsSelectedPrinter" (ngModelChange)="onPrinterChange($event)">
          <option *ngFor="let p of nsPrinters" [value]="p">{{ p }}</option>
        </select>
      </label>

      <div class="pick__label-actions">
        <button type="button" class="btn btn-link" (click)="setAllLabels(true)">Select all</button>
        <button type="button" class="btn btn-link" (click)="setAllLabels(false)">Select none</button>
      </div>

      <ul class="pick__label-list">
        <li *ngFor="let l of labelSelection">
          <label><input type="checkbox" [(ngModel)]="l.checked"> Basket {{ l.number }}</label>
        </li>
      </ul>

      <div class="pick__dialog-actions">
        <button class="btn btn-secondary" (click)="closePrintPanel()">Close</button>
        <button class="btn btn-primary" (click)="printSelectedLabels()">Print selected</button>
      </div>
    </div>
  </div>
</div>
